<div class="stripe-result failed">
  <div class="stripe-card">
    <div class="status-icon failed">
      <svg viewBox="0 0 24 24">
        <path d="M6 6l12 12M18 6L6 18" />
      </svg>
    </div>

    <h1>Payment failed</h1>
    <p>We couldn’t complete your payment. No charges were made.</p>

    <button class="stripe-btn secondary" (click)="goBackToApp()">
      Cancel
    </button>
  </div>
</div>
